import { type Control, Controller } from "react-hook-form";
import { FormButton } from "../search/TravelForm";
import { i18n } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
import { SearchRequest } from "@services/travel";

interface SearchDateProps {
  control: Control<SearchRequest>;
  way: string;
}

export function SearchDate({ control, way }: SearchDateProps) {
  const { t } = useTranslation();

  function displayDate(d: Date | undefined): string {
    if (!d) {
      return `+ ${t("add")}`;
    }
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return new Intl.DateTimeFormat(i18n.language, options).format(d);
  }

  if (way === "outward") {
    return (
      <>
        <span className="font-jakarta text-xl text-neutral-900 my-2">
          {t("exchange.searchForm.departure")}
        </span>

        <div>
          <Controller
            name="outwardDate.date"
            control={control}
            rules={{
              required: t("form.departureDate.required"),
            }}
            render={({ field, fieldState }) => (
              <FormButton
                data-testid="search-departuredate-button"
                icon="calendar_2_line"
                prefix={t("search.departureAt")}
                className="border-grey-blue-500 border-2"
                suffix={displayDate(field.value)}
                error={fieldState.error?.message}
              />
            )}
          />
        </div>
      </>
    );
  } else if (way === "inward") {
    return (
      <>
        <span className="font-jakarta text-xl text-neutral-900 my-2">
          {t("exchange.searchForm.departure")}
        </span>

        <div>
          <Controller
            name="inwardDate.date"
            control={control}
            rules={{
              required: t("form.departureDate.required"),
            }}
            render={({ field, fieldState }) => (
              <FormButton
                data-testid="search-returndate-button"
                icon="calendar_2_line"
                prefix={t("search.departureAt")}
                className="border-grey-blue-500 border-2"
                suffix={displayDate(field.value)}
                error={fieldState.error?.message}
              />
            )}
          />
        </div>
      </>
    );
  } else {
    throw new Error("Invalid way");
  }
}
